export default "__VITE_ASSET__M1Nl0EJY__"